<template>
  <div class="wowWeWork">
    <BreadsCrums page="howWeWork" previous="home" />
    <div class="garden-title text-center">
      <h3>{{ $t("ourValues") }}</h3>
      <p>{{ $t("ourValuesText") }}</p>
    </div>
    <NosValeurs />
    <section class="services-v5 garden-set-pd-sm">
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-sm-6">
            <div class="boxItem clearfix">
              <div class="box-text">
                <a href="#">
                  <h3>{{ $t("recherche") }}</h3>
                </a>
                <p>{{ $t("rechercheText") }}</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-6">
            <div class="boxItem clearfix">
              <div class="box-text">
                <a href="#">
                  <h3>{{ $t("conseil") }}</h3>
                </a>
                <p>{{ $t("conseilText") }}</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-6">
            <div class="boxItem clearfix">
              <div class="box-text">
                <a href="#">
                  <h3>{{ $t("incubation") }}</h3>
                </a>
                <p>{{ $t("incubationText") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import NosValeurs from "../components/NosValeurs.vue";
export default {
  created() {
    document.title = this.$i18n.t("navBar.howWeWork");
  },
  name: "HowWeWork",
  components: {
    NosValeurs
  }
};
</script>
<style scoped>
.garden-title h3 {
  font-family: "Poppins", sans-serif;
  font-size: 36px;
  line-height: 40px;
  color: #64a507;
}
.services-v5 {
  background: url("https://res.cloudinary.com/yanfomaweb/image/upload/v1576988609/afrikeveil/sv-bg.png");
  background-size: cover;
  background-position: center;
  font-size: 55px;
  color: #f9f9f9;
}
.boxItem {
  width: auto;
  background-color: rgba(234, 234, 234, 0.2);
  height: 550px;
  justify-content: center;
  text-align: center;
  padding: 17px;
  padding-top: 30px;
  border-radius: 8px;
  border: 2px solid #fff;
  -webkit-transition: all 0.5s ease-out;
  -moz-transition: all 0.5s ease-out;
  -o-transition: all 0.5s ease-out;
  transition: all 0.5s ease-out;
  margin-bottom: 20px;
}
.boxItem p {
  font-size: 14px;
  color: #ebebeb;
  font-weight: 400;
  color: #f9f9f9;
  text-align: justify;
  margin-bottom: 30px;
  display: block;
  -webkit-transition: all 0.5s ease-out;
  -moz-transition: all 0.5s ease-out;
  -o-transition: all 0.5s ease-out;
  transition: all 0.5s ease-out;
}
.boxItem h3 {
  font-family: "Poppins", sans-serif;
  font-size: 44px;
  color: #f9f9f9;
  font-weight: 700;
  text-transform: capitalize;
  margin-bottom: 25px;
}
</style>
